import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import "./PointAndCashSection.scss"

import { enLocaleNumberFormatter } from "utils";
import { detectIsPadOrMobileByScreenWidth } from "utils/ScreenUtils";
import { HIDE_POINT_TO_CASH_SECTION } from "utils/Config";
import { inMiniProgram, navigateStack } from "utils/WeChatUtil";
import { CashDollarIcon, PointsIcon } from "component/base/SvgIcons";
import UsePointToCashModal from "./UsePointToCashModal";

export const POINT_TO_CASH_CONVERT_RATE = 1000;

export const getMaxCashDollar = (points) => {
  if (points <= 0) {
    return 0;
  };
  return Math.floor(points / POINT_TO_CASH_CONVERT_RATE) || 0;
}

const hidePointToCashClassName = HIDE_POINT_TO_CASH_SECTION ? "hide-point-to-cash" : "";

const mapStateToProps = state => {
  return {
    currentPoints: state.users.availablePoints,
  };
};

const MobilePointToCashSection = ({
  currentPoints,
  t,
}) => {
  const history = useHistory();

  if (HIDE_POINT_TO_CASH_SECTION) {
    return <></>
  }

  return (
    <div
      className="use-cash-dollar-section mobile-view"
      onClick={() => {
        navigateStack({ pathname: "/use_cash_dollar", history })
      }}
    >
      <div className="background-icon" />
      <CashDollarIcon />
      <div className={`cash-dollar-title subheading color-p2`}>
        {`${t("use_cash_dollar")} (${enLocaleNumberFormatter(currentPoints)})`}
      </div>
    </div>)
}

const DesktopPointAndCashSection = ({
  currentPoints,
  t
}) => {
  const isMobile = detectIsPadOrMobileByScreenWidth();
  const maxCashDollar = getMaxCashDollar(currentPoints);

  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  const onClickSection = () => {
    if (HIDE_POINT_TO_CASH_SECTION) {
      return;
    };
    if (isMobile) {
      navigateStack({ pathname: "/use_cash_dollar", history })
      return;
    }
    if (!showModal) {
      setShowModal(true);
    }
  }

  return (
    <>
      <div className={`use-cash-dollar-section ${hidePointToCashClassName}`} onClick={onClickSection}>
        <div className="background-icon" />
        <div className={`cash-dollar-title subheading ${hidePointToCashClassName}`}>{t("use_cash_dollar")}</div>
        <div className="use-cash-dollar-content">
          <div className="point-content">
            <PointsIcon />
            <div>
              <div className="common-profile-section-text field-text">{t("my_points")}</div>
              <div className="cash-dollar-num-text headline">{enLocaleNumberFormatter(currentPoints)}</div>
            </div>
          </div>
          <div className={`point-to-cash-equal ${hidePointToCashClassName}`} >{"="}</div>
          <div className={`point-content ${hidePointToCashClassName}`}>
            <CashDollarIcon className="cash-dollar-icon" />
            <div>
              <div className="common-profile-section-text field-text">{t("cash_dollar")}</div>
              <div className="cash-dollar-num-text headline">{enLocaleNumberFormatter(maxCashDollar)}</div>
            </div>
          </div>
          <img alt="icon" src={"/profile/right-arrow.png"} className={`point-to-cash-right-arrow ${hidePointToCashClassName}`} />
        </div>
      </div>
      <UsePointToCashModal 
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </>
  )
}

function PointAndCashSection({
  currentPoints,
  t
}) {
  const isMobile = detectIsPadOrMobileByScreenWidth();
  const isInMiniProgram = inMiniProgram();
  return <>
    {isMobile || isInMiniProgram ?
      <MobilePointToCashSection
        currentPoints={currentPoints}
        t={t}
      />
      : <DesktopPointAndCashSection
        currentPoints={currentPoints}
        t={t}
      />}
  </>
}
export default connect(mapStateToProps)(withTranslation()(PointAndCashSection));
